var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3EAFF;}\r\n\t.st1{fill:#278DEC;}\r\n\t.st2{fill:#1F9978;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,23.7L12,23.7C5.5,23.7,0.3,18.5,0.3,12l0,0C0.3,5.5,5.5,0.3,12,0.3l0,0c6.5,0,11.7,5.2,11.7,11.7l0,0 C23.7,18.5,18.5,23.7,12,23.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.5,15.7c0.3,0,0.6,0,1,0c0,0,0.1,0,0.1,0.1c0,0.6,0.1,1.3-0.1,1.9c-0.3,1.1-1.3,1.9-2.5,1.9 c-1.5,0-3,0-4.5,0c-1.1,0-2.3,0-3.4,0c-0.9,0-1.7-0.4-2.2-1.2c-0.2-0.4-0.4-0.8-0.4-1.3c0-0.6,0-1.2,0-1.8c0.1-0.9,0.5-1.7,1-2.4 c0.3-0.4,0.7-0.7,1.2-1c0,0,0.1-0.1,0.2-0.1c0.2,0.3,0.3,0.6,0.5,0.9c-0.2,0.2-0.4,0.3-0.6,0.5c-0.8,0.7-1.2,1.6-1.2,2.7 c0,0.4,0,0.8,0,1.2c0,0.9,0.7,1.6,1.6,1.6c2.6,0,5.3,0,7.9,0c0.9,0,1.6-0.7,1.6-1.6C17.5,16.5,17.5,16.1,17.5,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,12c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8C15.8,10.3,14.1,12,12,12z M12,5.5 c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8c1.5,0,2.7-1.2,2.7-2.7C14.7,6.7,13.5,5.5,12,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.9,15.1c1.3-1.3,2.6-2.6,3.9-3.9c0.2,0.3,0.5,0.5,0.7,0.7c-1.5,1.5-3.1,3.1-4.6,4.6 c-0.8-0.8-1.6-1.6-2.5-2.5c0.2-0.2,0.5-0.5,0.7-0.7C12.7,13.9,13.3,14.5,13.9,15.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignRole);
export default __webpack_public_path__ + "static/media/assignRole.74c0d018271da1cef9609ba69b587b1f.svg";
export { ForwardRef as ReactComponent };